import { Link } from 'react-router-dom';
import { getNewDramas } from '@/mocks/dramas';

export default function LatestSection() {
  const newDramas = getNewDramas();

  if (newDramas.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              刚更新的热剧，第一时间追更
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {newDramas.map((drama) => (
            <Link
              key={drama.slug}
              to={`/detail/${drama.slug}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-50/80 transition-all duration-300 cursor-pointer"
            >
              <div className="w-24 md:w-28 shrink-0 overflow-hidden rounded-lg">
                <img
                  src={drama.coverImage}
                  alt={drama.title}
                  title={drama.title}
                  className="w-full aspect-[3/4] object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="px-1.5 py-0.5 text-xs rounded bg-accent-100 text-accent-700 font-medium">
                      {drama.status}
                    </span>
                    <span className="text-xs text-foreground-400">{drama.year}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                    {drama.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {drama.description}
                  </p>
                </div>

                <div className="flex items-center gap-2 mt-3">
                  <span className="text-xs text-foreground-600">
                    <i className="ri-star-fill text-accent-500 mr-1"></i>
                    {drama.rating}
                  </span>
                  <span className="text-xs text-foreground-400">{drama.updateInfo}</span>
                </div>

                <div className="flex flex-wrap gap-1 mt-2">
                  {drama.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="px-1.5 py-0.5 text-xs rounded bg-secondary-100 text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}